<template>
   <van-tabbar route v-model="active" placeholder fixed style="font-size:20px !important">
      <!-- <van-tabbar-item name="home" icon="home-o">
        <span class="f-14">首页</span>
        <template #icon>
          <van-icon size="26" color="#bebebe" name="wap-home-o" />
        </template>
      </van-tabbar-item> -->
      <van-tabbar-item class="iconfont" icon-prefix='icon' icon="shouye" name="home" to="/">首页</van-tabbar-item>
      <van-tabbar-item class="iconfont" icon-prefix='icon' icon="gongdan" name="search" to="/repair/0">维修</van-tabbar-item>
      <van-tabbar-item class="iconfont" icon-prefix='icon' icon="APP-" name="friends" to="/repair/1">保养</van-tabbar-item>
      <van-tabbar-item class="iconfont" icon-prefix='icon' icon="wode" name="setting" to="/user/index">我的</van-tabbar-item>
    </van-tabbar>
</template>

<script>
import {
  Tabbar,
  TabbarItem
} from "vant";

export default {
  name: "MainMenuNav",
  props: {},
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {
      active: "home",
      company:{}
    };
  },
  mounted(){
    this.global.getMemberSystem().then((memberSystem) => {
      if (!this.global.isNull(memberSystem)) {
        this.company = memberSystem;
      }
    });
  }
};
</script>
